import { QUERY_FIELD_PARAM_MAP } from "../constants/similarsteps";

export function buildAdvancedQuery(conditions, attributesMap) {
  if (!conditions?.length) return null;
  return conditions.map((condition, index) => {
    const isOuterHtml = condition.field === "outerHtml";
    const selectedKeys = Array.isArray(condition.attributeKey) ? condition.attributeKey : [];
    const field = QUERY_FIELD_PARAM_MAP[condition.field] ?? condition.field;
    const logicalOp = index === 0 ? undefined : condition.logicalOp;
    if (isOuterHtml) {
      return {
        field,
        ...(selectedKeys.length > 0
          ? { subFields: selectedKeys.map((k) => ({ field: k, value: attributesMap[k] ?? "" })) }
          : {}),
        logicalOp,
      };
    }
    return {
      field,
      operator: condition.operator,
      value: condition.useSourceValue !== false ? "" : condition.value.trim(),
      logicalOp,
    };
  });
}
